/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordSetAttestationData
 */
export interface PasswordSetAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordSetAttestationData interface.
 */
export function instanceOfPasswordSetAttestationData(value: object): value is PasswordSetAttestationData {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function PasswordSetAttestationDataFromJSON(json: any): PasswordSetAttestationData {
    return PasswordSetAttestationDataFromJSONTyped(json, false);
}

export function PasswordSetAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordSetAttestationDataToJSON(json: any): PasswordSetAttestationData {
    return PasswordSetAttestationDataToJSONTyped(json, false);
}

export function PasswordSetAttestationDataToJSONTyped(value?: PasswordSetAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
    };
}

